var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperatureTomorrowio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    className: "weather-filter-parameter__icon--Huru",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15,13.0226V4.9999c0-1.6569-1.3431-3-3-3s-3,1.3431-3,3v8.0226 c-1.2078,0.9127-2,2.3469-2,3.9774c0,2.7614,2.2386,5,5,5s5-2.2386,5-5C17,15.3694,16.2078,13.9353,15,13.0226z M12.9999,9h-2 V4.9999c0-0.5513,0.4482-1,1-1s1,0.4487,1,1V9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureTomorrowio);
export default __webpack_public_path__ + "static/media/temperature-tomorrowio.ec6ad4675740f35c17c4b7d313ae1384.svg";
export { ForwardRef as ReactComponent };